export const TrustRequestedActionsEnum = {
  TrustEstablishedInAWill: 'TRUST_ESTABLISHED_IN_A_WILL',
  TrustEstablishedByCourtOrder: 'TRUST_ESTABLISHED_BY_COURT_ORDER',
} as const satisfies Record<string, string>;

export const TrustRequestedActionsLabels = {
  [TrustRequestedActionsEnum.TrustEstablishedInAWill]:
    'Trust Established in a Will',
  [TrustRequestedActionsEnum.TrustEstablishedByCourtOrder]:
    'Trust Established by Court Order',
} as const;
export type TrustRequestedAction =
  (typeof TrustRequestedActionsEnum)[keyof typeof TrustRequestedActionsEnum];
